

export default () => {
  return <div class="footer">
    <div>
      Copyright © 2022 <strong>Everlens Admin Panel</strong> All rights reserved.
    </div>
  </div>
}